import axios from 'axios';
import { getToken, getTokenTokenType } from '../auth';

const baseURL = process.env.REACT_APP_API_BASE_URL ||
    (process.env.NODE_ENV === 'production'
        ? 'https://your-production-domain.com/negrospower/api'
        : 'http://localhost:8000');

const api = axios.create({ baseURL });

export const authHeaders = () => {
    const token = getToken();
    const tokenType = getTokenTokenType();
    return token ? { Authorization: `${tokenType} ${token}` } : {};
};

export default api;